import { stringify } from "@angular/compiler/src/util";
import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // Full screen
  public fullScreen: boolean = false;

  public Role: any = localStorage.getItem("CamlRole");
  public RoleCamlGATE = 1; // private admin only
  public RoleCamlEmployee = 2; // private admin only
  public RoleCompany = 5; // private Company only
  public RoleCompanyEmployee =  3; // private Company only
  public RoledCompanyTruck = 6; // private CompanyTruck  only
  public RoledCompanyTruckEmployee=4; // private CompanyTruck  only


  constructor(private router: Router) {
    
   
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS_andalus: Menu[] = [
    
    {
      title: "لوحة تحكم",
      icon: "dashboard",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/Online-Donations-Stats",
          title: "تبرعات الاونلاين",
          type: "link",
        },
      ],
    }, 
    {
      title: "دولة",
      icon: "map",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewCountry",
          title: "إدارة الدولة",
          type: "link",
        },
      ],
    },
    {
      title: "محافظة",
      icon: "disc",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewGovernorate",
          title: "إدارة المحافظات",
          type: "link",
        },
      ],
    },
    {
      title: "مدينة",
      icon: "flag",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewCity",
          title: "إدارة المدن",
          type: "link",
        },
      ],
    },
    
    
        // will add job route in menui  
        // {
        //   title: "وظيفه",
        //   icon: "activity",
        //   type: "sub",
        //   badgeType: "success",
        //   children: [
        //     {
        //       path: "admin/List-Job",
        //       title: "إدارة الوظائف",
        //       type: "link",
        //     },
        //   ],
        // },
        // will add Campaign route in menui  
        // {
        //   title: "الحملة",
        //   icon: "activity",
        //   type: "sub",
        //   badgeType: "success",
        //   children: [
        //     {
        //       path: "admin/List-Campaign",
        //       title: "إدارة الحملات",
        //       type: "link",
        //     },
        //   ],
        // },
    // {
    //   title: "طلب تبرع",
    //   icon: "phone",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewDonationCallRequest",
    //       title: "إدارة طلبات التبرعات",
    //       type: "link",
    //     },
    //   ],
    // },
    // {
    //   title: "فئة التبرع",
    //   icon: "activity",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewDonationCategory",
    //       title: "إدارو فئات التبرع",
    //       type: "link",
    //     },
    //   ],
    // },
    // {
    //   title: "نوع التبرع الرئيسي",
    //   icon: "upload-cloud",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewDonationmainType",
    //       title: "إدارة نوع التبرعات",
    //       type: "link",
    //     },
    //   ],
    // },
    // {
    //   title: "نوع التبرع",
    //   icon: "activity",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewDonationType",
    //       title: "إدارة انواع التبرع",
    //       type: "link",
    //     },
    //   ],
    // },
    {
      title: "المشاريع",
      icon: "activity",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewProjects",
          title: "إدارة المشاريع",
          type: "link",
        },
      ],
    },
    {
      title: "طرق التبرع",
      icon: "activity",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewDonationWay",
          title: "إدارة طرق التبرع ",
          type: "link",
        },
      ],
    },
    // {
    //   title: "الأحداث",
    //   icon: "coffee",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewEvent",
    //       title: "إدارة الاحداث",
    //       type: "link",
    //     },
    //   ],
    // },
    {
      title: "الاخبار",
      icon: "activity",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewNews",
          title: "إدارة الاخبار",
          type: "link",
        },
      ],
    },
    // {
    //   title: " طلبات التوظيف",
    //   icon: "users",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     // {
    //     //   path: "admin/ViewJoinRequest",
    //     //   title: "إدارة طلبات الانضمام",
    //     //   type: "link",
    //     // },
    //     {
    //       path: "admin/ViewEmploymentRequest",
    //       title: "إدارة طلبات التوظيف",
    //       type: "link",
    //     }
    //   ],
    // },
    // {
    //   title: " طلبات الدورات التدريبية",
    //   icon: "clipboard",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     // {
    //     //   path: "admin/ViewJoinRequest",
    //     //   title: "إدارة طلبات الانضمام",
    //     //   type: "link",
    //     // },
    //     {
    //       path: "admin/ViewCoursesRequest",
    //       title: "إدارة طلبات الدورات التدريبية",
    //       type: "link",
    //     }
    //   ],
    // },
    // {
    //   title: " طلبات التطوع",
    //   icon: "thumbs-up",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     // {
    //     //   path: "admin/ViewJoinRequest",
    //     //   title: "إدارة طلبات الانضمام",
    //     //   type: "link",
    //     // },
    //     {
    //       path: "admin/ViewVolunteeringRequest",
    //       title: "إدارة طلبات التطوع",
    //       type: "link",
    //     },
    //   ],
    // },
    {
      title: "الشركاء",
      icon: "activity",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/OurPartners",
          title: "إدارة الشركاء",
          type: "link",
        },
        // {
        //   path: "admin/ViewPartnerRequest",
        //   title: "طلبات الشركاء",
        //   type: "link",
        // },
        
      ],
    },
    // {
    //   title: "الموردين والشركاء",
    //   icon: "activity",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewPartnerRequest",
    //       title: "إدارة الشركاء و الموردين",
    //       type: "link",
    //     },
    //   ],
    // },
    // {
    //   title: "الجمعيات الاهلية",
    //   icon: "activity",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewNGOrganizations",
    //       title: "إدارة الجمعيات الاهلية",
    //       type: "link",
    //     },
    //   ],
    // },
    {
      title: "الاستفسارات",
      icon: "activity",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewInquiry",
          title: "إدارة الاستفسارات",
          type: "link",
        },
      ],
    },
  
    {
      title: "إدارة الصور",
      icon: "folder",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewPhoto",
          title: " الصور",
          type: "link",
        },
        {
          path: "admin/ViewPhotoAlbum",
          title: " البوم الصور",
          type: "link",
        },
        
      ],
    },

    {
      title: "إدارة الفيديو",
      icon: "folder",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewVideo",
          title: " الفيديو",
          type: "link",
        },
        {
          path: "admin/ViewVideoAlbum",
          title: " البوم الفيديو",
          type: "link",
        },
      
      ],
    },
    // {
    //   title: "إدارة النشاط",
    //   icon: "share-2",
    //   type: "sub",
    //   badgeType: "success",
    //   children: [
    //     {
    //       path: "admin/ViewSector",
    //       title: "النشاط",
    //       type: "link",
    //     },
    //     {
    //       path: "admin/ViewSectorLocation",
    //       title: " موقع النشاط",
    //       type: "link",
    //     },
    //     {
    //       path: "admin/ViewSectorType",
    //       title: " نوع النشاط",
    //       type: "link",
    //     },
    //   ],
    // },
  
    {
      title: "كلمات دليلية",
      icon: "activity",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewKeywords",
          title: "إدارة الكلمات الدليلية ",
          type: "link",
        },
      ],
    },
    {
      title: "المستخدمين",
      icon: "user-plus",
      type: "sub",
      badgeType: "success",
      children: [
        {
          path: "admin/ViewUser",
          title: "إدارة المستخدمين",
          type: "link",
        },
      ],
    },
    {
      title: "التقارير",
      icon: "map",
      type: "sub",
      badgeType: "success",
      children: [
           {
          path: "admin/DonationsReport",
          title: "تقرير التبرعات",
          type: "link",
        }
      //   {
      //     path: "admin/JobRequestReport",
      //     title: "تقاير طلبات التوظيف",
      //     type: "link",
      //   },
      //   {
      //     path: "admin/VoluntaryRequestReport",
      //     title: "تقاير طلبات التطوع",
      //     type: "link",
      //   },
      //   {
      //     path: "admin/TrainingCoursesReport",
      //     title: "تقاير  الدورات التدريبية",
      //     type: "link",
      //   },
      //   {
      //     path: "admin/NationalOrganizationReport",
      //     title: "تقاير الجمعيات الاهلية",
      //     type: "link",
      //   },
      //   {
      //     path: "admin/PartnerRequestReport",
      //     title: "تقاير انضمام شريك او مورد",
      //     type: "link",
      //   },
    
      ],
    },
  ];
// ===============
  MEGAMENUITEMS: Menu[] = [
    {
      title: "Error Pages",
      type: "sub",
      active: true,
      children: [
        {
          path: "javascript:void(0);",
          title: "Error Page 400",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Error Page 401",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Error Page 403",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Error Page 404",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Error Page 500",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Error Page 503",
          type: "extLink",
        },
      ],
    },
    {
      title: "Authentication",
      type: "sub",
      active: false,
      children: [
        { path: "javascript:void(0);", title: "Login Simple", type: "extLink" },
        {
          path: "javascript:void(0);",
          title: "Login BG Image",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Login BG Video",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Simple Register",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Register BG Image",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Register BG Video",
          type: "extLink",
        },
      ],
    },
    {
      title: "Usefull Pages",
      type: "sub",
      active: false,
      children: [
        { path: "javascript:void(0);", title: "Search Pages", type: "extLink" },
        { path: "javascript:void(0);", title: "Unlock User", type: "extLink" },
        {
          path: "javascript:void(0);",
          title: "Forgot Password",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Reset Password",
          type: "extLink",
        },
        { path: "javascript:void(0);", title: "Maintenance", type: "extLink" },
      ],
    },
    {
      title: "Email templates",
      type: "sub",
      active: false,
      children: [
        {
          path: "http://admin.pixelstrap.com/cuba/theme/basic-template.html",
          title: "Basic Email",
          type: "extTabLink",
        },
        {
          path: "http://admin.pixelstrap.com/cuba/theme/email-header.html",
          title: "Basic With Header",
          type: "extTabLink",
        },
        {
          path: "http://admin.pixelstrap.com/cuba/theme/template-email.html",
          title: "Ecomerce Template",
          type: "extTabLink",
        },
        {
          path: "http://admin.pixelstrap.com/cuba/theme/template-email-2.html",
          title: "Email Template 2",
          type: "extTabLink",
        },
        {
          path: "http://admin.pixelstrap.com/cuba/theme/ecommerce-templates.html",
          title: "Ecommerce Email",
          type: "extTabLink",
        },
        {
          path: "http://admin.pixelstrap.com/cuba/theme/email-order-success.html",
          title: "Order Success",
          type: "extTabLink",
        },
      ],
    },
    {
      title: "Coming Soon",
      type: "sub",
      active: false,
      children: [
        {
          path: "javascript:void(0);",
          title: "Coming Simple",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Coming BG Image",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Coming BG Video",
          type: "extLink",
        },
      ],
    },
  ];

  LEVELMENUITEMS: Menu[] = [
    {
      path: "javascript:void(0);",
      title: "File Manager",
      icon: "git-pull-request",
      type: "extLink",
    },
    {
      title: "Users",
      icon: "users",
      type: "sub",
      active: false,
      children: [
        {
          path: "javascript:void(0);",
          title: "All Users",
          icon: "users",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "User Profile",
          icon: "users",
          type: "extLink",
        },
        {
          path: "javascript:void(0);",
          title: "Edit Profile",
          icon: "users",
          type: "extLink",
        },
      ],
    },
    {
      path: "javascript:void(0);",
      title: "Bookmarks",
      icon: "heart",
      type: "extLink",
    },
    {
      path: "javascript:void(0);",
      title: "Calender",
      icon: "calendar",
      type: "extLink",
    },
    {
      path: "javascript:void(0);",
      title: "Social App",
      icon: "zap",
      type: "extLink",
    },
  ];

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS_andalus);
 

  


  megaItems = new BehaviorSubject<Menu[]>(this.MEGAMENUITEMS);
  levelmenuitems = new BehaviorSubject<Menu[]>(this.LEVELMENUITEMS);
}

